import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../routing/helpers/router';
import * as moduleAction from '../../../store/actions/moduleAction';
import { useSelector } from 'react-redux';

export default function ModuleInecoRiskManagerBase() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const permissions = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge
  );
  const userBridge = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge
  );

  // > LOAD MODULE DATA //
  const loadModuleData = useCallback(async () => {
    dispatch(
      moduleAction.fetch(
        axiosPath("api_r_user_module_inecoRiskManager_getModuleData"),
        "moduleData",
        {
          moduleBridgeHex,
        }
      )
    );
  }, []);

  useEffect(() => {
    if (!moduleData) loadModuleData();
  }, []);
  // > LOAD MODULE DATA //

  // < STORE CALLS
  const loadModulePermissions = useCallback(async () => {
    try {
      await dispatch(
        moduleAction.fetch(
          axiosPath("api_r_user_module_inecoRiskManager_getPermissions"),
          "permissions",
          {
            moduleBridgeHex,
            subType: "permissions",
          }
        )
      );
      await dispatch(
        moduleAction.fetch(
          axiosPath("api_r_user_module_inecoRiskManager_getPermissions"),
          "userBridge",
          {
            moduleBridgeHex,
            subType: "userBridge",
          }
        )
      );
    } catch (err) {}
  }, [moduleBridgeHex]);

  useEffect(() => {
    if (!permissions || !userBridge) loadModulePermissions();
  }, [moduleBridgeHex]);
  // < STORE CALLS

  return null;
}
